import React from "react";

const LogoCompetition = () => {
  return (
    <>
      <h4 style={{ textAlign: "center" }}>University of Nepal (UNepal)</h4>
      <h3 style={{ textAlign: "center" }}>
        Notice: Open Competition for Logo Design
      </h3>
      <p style={{ textAlign: "center" }}>
        Date of Publication: August 30, 2025 (2082/05/14)
      </p>

      <br />

      <p>
        The University of Nepal (UNepal), a public university established by the
        Act of Nepal’s Federal Parliament, invites entries from individuals and
        institutions in Nepal and abroad for designing its official logo. The
        logo should reflect UNepal’s mission of emerging as a premier university
        committed to quality higher education and producing graduates who are
        globally competent and locally relevant.
      </p>

      <p>
        The logo should be artistic, creative, elegant, simple, inspiring,
        memorable, and versatile in design. All submissions must be in
        high-resolution digital format (vector preferred).
      </p>

      <p>
        A jury will shortlist three designs, and the UNepal Board of Trustees
        will select the final logo. The winner shall be required to provide
        design variants of the adopted logo, along with the full transfer of
        ownership and usage rights to UNepal. The winner will receive a cash
        prize of NPR 25,000 and a Certificate of Recognition, and the winning
        design will be adopted as the official logo of the University of Nepal.
        The two other finalists will each receive a cash prize of NPR 10,000 and
        a Certificate of Appreciation.
      </p>

      <br />

      <p>
        <strong>Submission Deadline:</strong> 15 September 2025 <br />
        <strong>Submission Email:</strong>{" "}
        <a href="mailto:info@uon.edu.np">info@uon.edu.np</a> <br />
        <strong>Details:</strong>{" "}
        <a href="https://www.uon.edu.np" target="_blank" rel="noreferrer">
          www.uon.edu.np
        </a>
      </p>
    </>
  );
};

export default LogoCompetition;
